module.exports = __webpack_public_path__ + "img/failed.0e8b5a29.svg";